<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: Object as PropType<{
      alignment: "left" | "center" | "right";
      extraText?: string;
      includePageNumbers: boolean;
    }>,
    required: true,
  },
  showRemoveButton: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue"]);

// Create a local reactive copy of the modelValue
const localValue = ref({
  alignment: props.modelValue.alignment,
  extraText: props.modelValue.extraText,
  includePageNumbers: props.modelValue.includePageNumbers,
});

// Watch for changes to the prop and sync to local state
watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = {
      alignment: newValue.alignment,
      extraText: newValue.extraText,
      includePageNumbers: newValue.includePageNumbers,
    };
  },
  { deep: true }
);

const save = () => {
  emit("update:modelValue", { ...localValue.value });
};

const remove = () => {
  emit("update:modelValue", undefined);
};
</script>

<template>
  <div>
    <h2 class="font-bold">Headers</h2>
    <BaseCheckbox
      v-model="localValue.includePageNumbers"
      label="Page Numbers"
      size="small"
      class="my-2"
    />
    <!-- <div class="flex flex-row mb-2">
      <div
        class="flex flex-row shadow bg-surface rounded border overflow-hidden"
      >
        <span
          class="p-1 flex items-center justify-center hover:bg-light-default"
          :class="{ 'bg-primary/10': localValue.alignment == 'left' }"
          @click="localValue.alignment = 'left'"
        >
          <BaseIconAlignLeft />
        </span>
        <span
          class="p-1 flex items-center justify-center hover:bg-light-default"
          :class="{ 'bg-primary/10': localValue.alignment == 'center' }"
          @click="localValue.alignment = 'center'"
        >
          <BaseIconAlignCenter />
        </span>
        <span
          class="p-1 flex items-center justify-center hover:bg-light-default"
          :class="{ 'bg-primary/10': localValue.alignment == 'right' }"
          @click="localValue.alignment = 'right'"
        >
          <BaseIconAlignRight />
        </span>
      </div>
    </div> -->

    <div class="text-[12pt] text-medium mt-2">Extra</div>
    <BaseTextInput v-model="localValue.extraText" @keyup.enter="save" />
    <div class="flex flex-row items-center justify-end mt-2 gap-1">
      <BaseIconButton @click="remove" color="danger" v-if="showRemoveButton">
        <BaseIconDelete />
      </BaseIconButton>
      <BaseButton @click="save" size="sm" class="w-[100px]"> Done </BaseButton>
    </div>
  </div>
</template>

<style scoped></style>
